import { apiRequest } from './client';

export interface LifetimeStats {
  total_cells_visited: number;
  earliest_cell_at: string | null;
  total_cities_touched: number;
  cities_above_one_percent: number;
  cities_above_ten_percent: number;
  most_visited_city: { city_id: string; name: string; visited_cells_count: number; percentage: number } | null;
}

export function fetchLifetimeStats(): Promise<LifetimeStats> {
  return apiRequest<LifetimeStats>('/stats/lifetime');
}
